export { default } from './FeaturedArticle';